export type scrollIntoViewPropsType = {
  scrollIntoView: (
    questionIdRefs: React.MutableRefObject<any>,
    quesId: string
  ) => void;
};

export const scrollIntoView: scrollIntoViewPropsType["scrollIntoView"] = (
  questionIdRefs,
  quesId
) => {
  const elementToScrollTo = questionIdRefs.current[quesId];
  if (elementToScrollTo) {
    elementToScrollTo.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};
